import { currencyInformation } from 'SRC/hooks/useCurrencyInformation';

export const currencies = Intl.supportedValuesOf?.('currency');

export function currencyDisplay(currency: string | null | undefined) {
  if (currency?.length !== 3) {
    return currency;
  }

  const name = currencyName(currency);
  if (name === currency) {
    return currency;
  }

  const namePair = `${currency} - ${name}`;
  const symbol = currencyNarrowSymbol(currency);

  // this should not happen but not all browsers have symbols for all currencies in Intl
  if (symbol === currency) {
    return namePair;
  }

  return `${namePair} (${symbol})`;
}

export const currencyName = (currency: string | undefined) =>
  (currency?.length === 3 &&
    new Intl.DisplayNames(undefined, { type: 'currency' }).of(currency)) ||
  '';

export const currencySymbol = (currency: string | undefined) =>
  (currency?.length === 3 &&
    new Intl.NumberFormat(undefined, { currency, style: 'currency' })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value) ||
  '¤';

export const currencyNarrowSymbol = (
  currency: string | undefined,
  fallback = '¤',
) =>
  (currency?.length === 3 &&
    new Intl.NumberFormat(undefined, {
      currency,
      style: 'currency',
      currencyDisplay: 'narrowSymbol',
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value) ||
  fallback;

export const currencyMinorUnits = (currency: string) =>
  currencyInformation.get(currency) ?? 0;

export const currencySubUnit = (currency: string, minorUnits?: number) =>
  10 ** (minorUnits ?? currencyMinorUnits(currency));
